<script>
  export let reviewer;
  export let index;
  export let version;
  export let miRol;
  export let revisionDocAuthors;
  export let revisionDocEditors;
  export let last;

  import { openDocument } from "../utils/openDocument";

  import { onMount } from "svelte";

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let estadoRevision;
  let estadoRevisionText = "-";
  let estadoColor = "";

  onMount(() => {
    estadoRevision =
      version === 1
        ? reviewer.decisionDocumento1.decision
        : reviewer.decisionDocumento2.decision;
    switch (estadoRevision) {
      case "Aceptado":
        estadoRevisionText = "- " + dict["aceptadoParaPublicacion"];
        estadoColor = "var(--revista-green)";
        break;
      case "CambiosMenores":
        estadoRevisionText = "- " + dict["aceptadoConCambiosMenores"];
        estadoColor = "var(--revista-orange)";
        break;
      case "CambiosMayores":
        estadoRevisionText = "- " + dict["aceptadoConCambiosMayores"];
        estadoColor = "var(--revista-orange-red)";
        break;
      case "Rechazado":
        estadoRevisionText = "- " + dict["rechazado"];
        estadoColor = "var(--revista-red)";
        break;
    }
    estadoRevisionText = estadoRevisionText.replace(/\./, "");
  });
</script>

<style>
  div.articleVersionReviewerItem {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  img.imgIcon {
    width: 20px;
    height: 20px;
  }

  div.document {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  div.last {
    padding-bottom: 0px;
    border-bottom-width: 0px;
  }

  div.imageIcon {
    margin-right: 20px;
    margin-left: 30px;
  }

  div.imageIcon img {
    width: 30px;
  }

  div.description {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  div.options {
    display: flex;
  }

  div.options img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }

  img.imgButton {
    cursor: pointer;
  }
</style>

{#if miRol === 'EditorJefe' || miRol === 'Editor' || (miRol === 'Revisor' && revisionDocAuthors !== '') || miRol === 'Autor' || miRol === 'AutorGestor'}
  <div class="articleVersionReviewerItem {last ? 'last' : ''}">
    <div>
      {#if miRol === 'Revisor'}
        {version === 1 ? moment(reviewer.decisionDocumento1.fechaRevision).format('DD MMMM YYYY HH:mm:ss') : moment(reviewer.decisionDocumento2.fechaRevision).format('DD MMMM YYYY HH:mm:ss')}
      {:else}
        {dict['revisor']} {index + 1}: {reviewer.nombreUsuario}
        {reviewer.apellido1Usuario} {reviewer.apellido2Usuario}
      {/if}
      <span style="color: {estadoColor}">{estadoRevisionText}</span>
      {#if estadoRevision === 'Aceptado'}
        <img
          class="imgIcon"
          src="/images/revista/revisor-v-color.svg"
          title={dict['decisionRevisorOk']}
          alt="Revision Icon" />
      {:else if estadoRevision === 'CambiosMenores'}
        <img
          class="imgIcon"
          src="/images/revista/revisor-v-minor-color.svg"
          title={dict['decisionRevisorNoOk']}
          alt="Revision Icon" />
      {:else if estadoRevision === 'CambiosMayores'}
        <img
          class="imgIcon"
          src="/images/revista/revisor-v-major-color.svg"
          title={dict['decisionRevisorNoOk']}
          alt="Revision Icon" />
      {:else if estadoRevision === 'Rechazado'}
        <img
          class="imgIcon"
          src="/images/revista/revisor-x-color.svg"
          title={dict['decisionRevisor']}
          alt="Revision Icon" />
      {/if}

      {#if estadoRevision !== ''}
        <div class="document {revisionDocEditors === '' ? 'last' : ''}">
          <div class="imageIcon">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(revisionDocAuthors)}>
              <img src="/images/revista/docx.svg" alt="Document" />
            </a>
          </div>
          <div class="description">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(revisionDocAuthors)}>
              {dict['cartaAutores']}
            </a>
          </div>
          <div class="options">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(revisionDocAuthors)}>
              <img
                class="imgButton"
                src="/images/revista/download.svg"
                alt="View Icon" />
            </a>
          </div>
        </div>
        {#if revisionDocEditors && revisionDocEditors.length > 0}
          <div class="document last">
            <div class="imageIcon">
              <a
                href="#"
                onclick="return false;"
                on:click={() => openDocument(revisionDocEditors)}>
                <img src="/images/revista/docx.svg" alt="Document" />
              </a>
            </div>
            <div class="description">
              <a
                href="#"
                onclick="return false;"
                on:click={() => openDocument(revisionDocEditors)}>
                {dict['cartaEditores']}
              </a>
            </div>
            <div class="options">
              <a
                href="#"
                onclick="return false;"
                on:click={() => openDocument(revisionDocEditors)}>
                <img
                  class="imgButton"
                  src="/images/revista/download.svg"
                  alt="View Icon" />
              </a>
            </div>
          </div>
        {/if}
      {/if}
    </div>
  </div>
{/if}
